__turbopack_context__.v({
  "modal": "MinimumOrderModal-module-scss-module__2BNYDa__modal",
  "modalBody": "MinimumOrderModal-module-scss-module__2BNYDa__modalBody",
  "modalFooter": "MinimumOrderModal-module-scss-module__2BNYDa__modalFooter",
});
